<template>
  <div>
    <div class="placeholder">
      {{ title }}
    </div>
  </div>
</template>

<script>
import RouteHelper from '@/mixins/RouteHelper'

export default {
  name: 'EmptyGroupListPlaceholder',
  mixins: [RouteHelper],
  computed: {
    title() {
      if (this.underSystemOwnerPage) {
        return '登録されている地点グループはありません'
      } else {
        return '地点グループを作成してください'
      }
    },
  },
}
</script>

<style scoped lang="scss">
.placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 24px;
  font-weight: bold;
  background-color: darken(#fff, 5%);
}
</style>
